import { VideoPlayer } from '@/components';
import { palette } from '@/theme/constants';
import { cdn_url } from '@/utils';
import { Box, useMediaQuery, Theme } from '@mui/material';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { FC } from 'react';

const VideoItem: FC<any> = ({ hideControls, color, item, name, elementSelected, handleSelectVideo, thumbnail }) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const router = useRouter();
  let bgColor = router.pathname === '/app/home' ? palette.primary : color;

  return (
    <Box
      position='relative'
      borderRadius='8px'
      border={elementSelected?.name === name ? `1px solid ${bgColor}` : 'none'}
      width={'100%'}
      height={'100%'}
      overflow='hidden'
      onClick={(e: any) => handleSelectVideo(e, { name, url: `${cdn_url}${item}` })}>
      <Box
        width='100%'
        height='100%'
        borderRadius='8px'
        display='flex'
        justifyContent='center'
        alignItems='center'
        bgcolor='rgba(0, 0, 0, 0.4)'
        position='relative'>
        {/* Play Icon */}
        <Image
          src='/icons/Play-white.svg'
          alt={item?.name}
          width={30}
          height={30}
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: isMobile ? 'translate(-50%, -50%)' : 'translate(-10%, -50%)',
            zIndex: 999,
          }}
        />

        {/* Video Thumbnail or Actual Video */}
        {item?.thumb ? (
          <Image
            src={`${cdn_url}${item?.thumb}`}
            alt={`${cdn_url}${item?.thumb}`}
            fill
            style={{ objectFit: 'contain', borderRadius: '8px' }}
            quality={80}
            priority
          />
        ) : (
          <VideoPlayer
            containerHeight={210}
            height={210}
            isThumbnail={true}
            // width={170}
            hideControls={hideControls}
            isSelected={elementSelected === item}
            disabledVideo
            config={{
              youtube: {
                playerVars: { showinfo: 0 },
              },
            }}
            url={`${item?.preview}` || ''}
            style={{ objectFit: 'cover', width: '100%', height: '100%', borderRadius: '8px' }}
          />
        )}
      </Box>
    </Box>
  );
};

export default VideoItem;
